export class InputButton {
  el: HTMLElement[];
  constructor(selector: string) {
    this.el = [...document.querySelectorAll(selector)] as HTMLElement[];
    this.initialize();
  }

  initialize() {
    this.el.forEach((el) => {
      el.setAttribute('tabindex', '0');
      const inputEl = el.querySelector('input') as HTMLInputElement;
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          inputEl.click();
        }
      });
    });
  }
}
